import Rete from 'rete'
import SkillsMindMapNode from '@views/pages/mindmap/mind-map-node'
import VueRenderPlugin from 'rete-vue-render-plugin'
import ConnectionPlugin from 'rete-connection-plugin'
import ConnectionPathPlugin from 'rete-connection-path-plugin'
import AreaPlugin from 'rete-area-plugin'
import ContextMenuPlugin from 'rete-context-menu-plugin'
import ConnectionPathVuePlugin from './connection-path-vue-plugin'
import mindMapPathComponent from "@views/pages/mindmap/mind-map-path-component";

const socket = new Rete.Socket('any')
const engine = new Rete.Engine('zabota@0.1.0')

// TODO: Вынести в языковой модуль
export const actionType = {
  call: 'Позвонить',
  speech_synthesis: 'Синтезировать голос',
  audio_play: 'Проиграть аудио',  
  audio_record: 'Записать ответ', 
  digital_input: 'Цифровой ввод',  
  audio_transcription: 'Распознать голос',  
  intent: 'Интент',
  goto: 'Переход к блоку',
  set_variables: 'Присвоить переменную',
  message_send: 'Отправить сообщение',  
  ai_request: 'Выполнить запрос к AI',  
  event_wait: 'Ожидать событие',  
  http_request: 'Выполнить HTTP-запрос',
  call_redirect: 'Переадресация звонка',    
  end_call: 'Завершить звонок',  
}

export const actionTypePath = {
  condition: {
    name: 'Логическое условие',
  },
  intent: {
    name: 'Интент',
  },
  default: {
    name: 'Переход',
  }
}

const contextMenuKeys = {
  DELETE: 'Удалить',
  EDIT: 'Редактировать',
  CHANGE_PATH: 'Изменить на',
}


class ComponentBuilder extends Rete.Component {
  constructor(component) {
    super(component.nodeName)
    this.data.component = component
  }

  builder(node) {
    const {inputs, outputs} = node.data.sockets

    if (inputs.length)
      for (const input of inputs)
        node.addInput(new Rete.Input(input, input, socket, true))

    if (outputs.length)
      for (const output of outputs)
        node.addOutput(new Rete.Output(output, output, socket, true))

    return node
  }
}


export const createEditor = async (selector, methods, fl_ai = false) => {
  const {
    onConnectCreate,
    onConnectRemove,
    onConnectSelected,
    onNodeDragged,
    onNodeEdit,
    onNodeRemove,
    onNodeCreate,
    onNodeSelected,
    onPathChangeType,
    onPathEdit,
  } = methods;

  const container = document.querySelector(selector)
  const component = new ComponentBuilder(SkillsMindMapNode)
  const editor = new Rete.NodeEditor('zabota@0.1.0', container)
  editor.freeze = false
  let contextClickPosition = [0, 0]
  let selectedPatch = null

  editor.bind('nodefocus')

  editor.use(VueRenderPlugin)
  editor.use(AreaPlugin, {  background: true })
  editor.use(ConnectionPlugin)
  editor.use(ConnectionPathPlugin, {
    type: ConnectionPathPlugin.DEFAULT,
    options: { vertical: true, curvature: 0.5 },
  })

  editor.use(ConnectionPathVuePlugin, {
    vuePathNodeComponent: mindMapPathComponent
  })

  let clickTimeStamp = null
  editor.view.area.container.addEventListener('mousedown', (e) => {
    if (e.target.classList.contains('rete-background'))
      clickTimeStamp = e.timeStamp
  })
  editor.view.area.container.addEventListener('mouseup', (e) => {
    if (clickTimeStamp && e.timeStamp - clickTimeStamp < 150)
      editor.trigger('click', e)
  })


  editor.use(ContextMenuPlugin, {
    searchBar: false,
    items: (() => {
      let components = {}
      for (const actionKey in actionType) {
        if (actionKey === 'ai_request' && !fl_ai) continue;
        components = {
          ...components,
          [actionType[actionKey]]: () =>
            onNodeCreate(actionKey, contextClickPosition),
        }
      }
      return components
    })(),
    nodeItems: (node) => {
      if (node.name === 'node'){
        const deleteItem = {
          [contextMenuKeys.DELETE]: onNodeRemove,
        }
        const editItem =
            node.editable !== false ? { [contextMenuKeys.EDIT]: onNodeEdit } : {}

        return { ...editItem, ...deleteItem, Delete: false, Clone: false }
      }
      if (node.name === 'path' || node.name === 'path-label'){
        const changeTypePath = {
          [contextMenuKeys.CHANGE_PATH]: (() =>
            Object.assign(
              ...Object.keys(actionTypePath)
                .map(key => {
                    if (node.connection.data.type !== key)
                      return {[actionTypePath[key].name]: () => onPathChangeType(node, key)}
                    return {}
                  }
                )
            )
          )()
        }

        const editPath = {
          [contextMenuKeys.EDIT]: onPathEdit
        }

        const deletePath = {
          [contextMenuKeys.DELETE]: () =>
            onConnectRemove(node.connection)
        }

        return {...editPath, ...changeTypePath, ...deletePath, Delete: false, Clone: false}
      }

    },
    allocate(component) {
      return null
    },
    delay: 1500
  })

  if (!editor.components.size) editor.register(component)
  if (!engine.components.size) engine.register(component)

  // блокировка открытия контекстного меню
  editor.on('contextmenu', () => {
    if (editor.freeze)
      editor.trigger('hidecontextmenu')
  })

  // Удаление пути при по пытке переопределения
  editor.on('connectionremove', () => {
    editor.trigger('resetconnection')
  })

  // Запоминаем координаты открытия контекстного меню
  editor.on('contextmenu', (event) => {
    if (event.view)
      contextClickPosition = [event.view.area.mouse.x, event.view.area.mouse.y]
  })


  // Сброс фокуса с элементов
  editor.on('clearfocus', () => {
    onConnectSelected(null)
    if (selectedPatch && selectedPatch.classList.contains('focus')) {
      selectedPatch.classList.remove('focus')
      selectedPatch = null
    }
  })

  // остановка вычислений, т.к. не используются
  editor.on('process nodecreated noderemoved', async () => {
    await engine.abort()
  })

  // повесить класс на сфокусированный путь
  editor.on('connetionfocus', (ref) => {
    editor.trigger('clearfocus')
    if ('focus' in ref)
      ref.focus()
  })

  editor.on('connectioncreated', onConnectCreate)
  editor.on('connectionremoved', onConnectRemove)
  editor.on('nodedragged', onNodeDragged)
  editor.on('nodeselect', () => editor.trigger('clearfocus'))
  editor.on('click', (e) => editor.trigger('clearfocus'))

  editor.view.resize()
  AreaPlugin.zoomAt(editor)

  return editor
}

export const reteRender = (editor, data, track=[]) => {

  // console.log('track')
  // console.log(track)

  if (!editor) return

  var default_child = null;
  var focus_connection = null;

  const connectionsParser = (element) => {
    if (!element.childs.length) return []

    if(!element.instanceId){
      default_child = null
      focus_connection = null
    }

    // console.log(element)

    const connections = []

    // console.log('element_id: ' + element.id)

    element.childs.map((child => {

      // Если блок ссылается на логический
      // console.log(child);
      if (child.type && child.type.includes('to_') && child.id){

        // получаем ссылку на логический блок
        const conditionalBlock = data.find((block) => block.id === child.id)
        if (!conditionalBlock) return

        // достаем потомков из логического блока
        const nestingChilds = connectionsParser(conditionalBlock)
        
        // записываем потомков логического блока в потомки родительского для логического
        if (nestingChilds) connections.push(...nestingChilds)
        return;
      }

      // иначе создаем обычные связи

      if(child.type === 'default'){
        default_child = child;
      } else {
        let set_focus = track.indexOf(element.id) !== -1 ? true : false
        if(set_focus === true){
          focus_connection = true
        }
        const connection = {
          node: child.id,
          input: 'input',
          data: {
            type: child.type,
            priority: child.priority,
            description: element.description,
            focus: set_focus
          }
        }
        connections.push(connection)
      }
    }))

    // console.log('focus_connection:')
    // console.log(focus_connection)

    if(default_child !== null){
      connections.push({
        node: default_child.id,
        input: 'input',
        data: {
          type: default_child.type,
          priority: default_child.priority,
          description: element.description,
          focus: focus_connection === null && track.indexOf(element.id) !== -1 ? true : false
        }
      })
    }

    return connections
  }

  const nodes = []

  data.map((element, index) => {

    // если блок логический - не отображаем на mindMap
    // if (element.action === 'intent' || element.action === 'condition') return
    if (element.action === 'condition' || (element.action === 'intent' && element.instanceId)) return

    const position = element.position && (element.position[0] || element.position[1]) ? element.position : [0, 0]

    // console.log(track)

    const node = {
        id: element.id,
        data: {
          sockets: element.sockets,
          index: index,
          description: element.description,
          action: element.action,
          focus: track.indexOf(element.id) !== -1 ? true : false
        },
        outputs: {
          'default': {
            connections: connectionsParser(element)
          }
        },
        position: position,
        name: 'node'
    }
    nodes.push({[element.id]: node})
  })

  return new Promise(async (resolve) => {
    // setTimeout(async () => {
    await engine.abort()
    await editor.fromJSON({
      id: 'zabota@0.1.0',
      nodes: nodes.length ? Object.assign(...nodes) : {},
    })
    return resolve(true)
    // }, 100)
  })
}
